import React from 'react'
import Layout from '../components/Layout'
import Button from 'antd/lib/button'
import 'antd/lib/button/style/css'
import { Link } from "gatsby"

const IndexPage = () => {
  return (
    <Layout>
      <div>
        <div align="center">
        <br/>
          <p style={{color: "cornflowerblue", fontSize: 50, fontWeight: 'bold', marginBottom: '1rem'}}>
            如何玩转云站
          </p>
          <h2>
            <img width="300" src="https://media.giphy.com/media/l0MYC0LajbaPoEADu/giphy.gif" alt="welcome" />
          </h2>
          <br/>
          <Link to="/docs/beginner/introduction">
            <Button type="primary" size="large" icon="right-circle" style={{marginRight: 10}}>开 始</Button>
          </Link>
        </div>
      </div>
    </Layout>
  )
}

export default IndexPage
